import React from 'react'
import dlv from 'dlv'
import kebabCase from 'kebabcase'

import { useNavStructure } from '../hooks'

import { Box } from 'system'
import { Subheading } from './Subheading'
import { TreeNav } from './TreeNav'

const isPlainObject = val =>
  val !== null && typeof val === 'object' && !Array.isArray(val)

const RecursiveTreeNavItems = ({ pairs, depth = 0 }) =>
  pairs.map(([title, value]) => {
    const Comp = depth > 0 ? TreeNav.ChildItem : TreeNav.Item

    if (isPlainObject(value))
      return (
        <Comp
          href={dlv(value, '_path', kebabCase(title))}
          title={title}
          key={title}
        >
          <RecursiveTreeNavItems
            pairs={Object.entries(value)}
            depth={depth + 1}
          />
        </Comp>
      )

    if (title.startsWith('_')) return

    return <Comp href={value} title={title} key={title} />
  })

const Group = ({ name, children, ...props }) => (
  <Box as="li" boxStyle="lastNoMargin" mb={5} {...props}>
    {name && <Subheading mbScale="s-">{name}</Subheading>}
    {children}
  </Box>
)

export const DocumentsNav = props => {
  const navStructure = useNavStructure()

  return (
    <Box as="nav" {...props}>
      <Box as="ul">
        {Object.entries(navStructure).map(([groupName, groupValues]) => (
          <Group name={groupName} key={groupName}>
            <TreeNav>
              <RecursiveTreeNavItems pairs={Object.entries(groupValues)} />
            </TreeNav>
          </Group>
        ))}
      </Box>
    </Box>
  )
}
